//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {dateFormatter} from '@nuskin/ns-util';
import {ProductStatus} from '../services/productStatus';
export default {
  name: 'ReplacementProductDetail',
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    variant: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Error, Object, String],
      default: null
    },
    discontinued: {
      type: Object,
      default: () => ({})
    },
    discontinuedproduct: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isButtonDisabled() {
      return !!this.statusKey && this.statusKey !== 'onBackorder';
    },
    availableQuantity() {
      return this.variant.atpQuantity || 0;
    },
    backorderQuantity() {
      return this.variant.backorderQuantity || 0;
    },
    backorderedAvailableDate() {
      return this.variant.backorderedAvailableDate || null;
    },
    traditionalLocale() {
      return this.$store.getters['nuskin/traditionalLocale'] || '';
    },
    siteUrl() {
      return this.$store.getters['nuskin/siteUrl'] || '';
    },
    fallbackImageSrc() {
      // TODO: move fallback image to ContentStack/other?
      return this.siteUrl
        ? `${this.siteUrl}/etc/designs/hello/packaged/img/product-basic__fallback-image.svg`
        : '';
    },

    statusKey() {
      const statusKey = 'status';
      const status = (this.variant.status || {})[statusKey];
      if (status === ProductStatus.Sellable) {
        if (this.variant.status.inventory === 'backordered') {
          return 'onBackorder';
        }
        if (this.variant.status.inventory === 'outOfStock') {
          return 'outOfStock';
        }
        if (this.isExclusive && this.availableQuantity === 0) {
          return 'reachedPurchaseLimit';
        }
        if (
          this.backorderedAvailableDate &&
          this.quantity > this.availableQuantity &&
          this.backorderQuantity
        ) {
          return 'onBackorder';
        }
      } else if (status === ProductStatus.Discontinued) {
        return 'discontinued';
      } else if (status === ProductStatus.Inactive) {
        return 'notReleasedForSale';
      } else if (status === ProductStatus.Stopped) {
        return 'stopStatus';
      } else if (status === ProductStatus.BundleOnly) {
        return 'notSoldSeperately';
      }
      return '';
    },
    statusType() {
      const statusKey = 'status';
      return (this.variant.status || {})[statusKey];
    },
    statusMessage() {
      const statusKey = this.statusKey;
      switch (statusKey) {
        case 'onBackorder':
          return this.$t('status.onBackorder').replace(
            '%date%',
            dateFormatter.getCountryFormattedDate(
              this.backorderedAvailableDate,
              this.traditionalLocale
            )
          );
        case 'reachedPurchaseLimit':
          return this.$t('status.reachedPurchaseLimit');
        case 'outOfStock':
          return this.$t('status.outOfStock');
        case 'discontinued':
          return this.$t('status.discontinued');
        case 'notReleasedForSale':
          return this.$t('status.notReleasedForSale');
        case 'stopStatus':
          return this.$t('status.stopStatus');
        case 'notSoldSeperately':
          return this.$t('status.notSoldSeperately');
        default:
          return '';
      }
    }
  },
  methods: {
    handleReplacementProductClick() {
      this.$emit('product-image');
      const Event = {
        event: 'replaced_product_click',
        ecommerce: {
          click: {
            actionField: {
              list: '',
              action: 'click',
              products: [
                {
                  id: this.variant.sku,
                  name: this.variant.title,
                  price: this.variant?.price?.retail,
                  // TODO: get category from ContentStack, 'Nu Skin' is the default value
                  brand: 'Nuskin',
                  category: this.variant?.productType,
                  item_type: 'replacement_product',
                  discontinued_product_name: this.discontinued?.title,
                  discontinued_product_id: this.discontinued?.sku,
                  page_url: this.discontinuedproduct?.seoInformation
                    ?.canonicalURL,
                  click_url: this.product?.href
                }
              ]
            }
          }
        },
        platform: 'Legacy'
      };
      this.$store.commit('nuskin/pushGoogleAnalyticsEvent', Event);
    },
    handleAddToCart() {
      if (!this.isButtonDisabled) {
        this.$emit('add-to-cart');
      }
    }
  }
};
